export default __webpack_public_path__ + "static/media/ic_lithuania.4948e04e.svg";